import { useEffect, useState } from "react"
import IndicatorsScreen from "../../screen/IndicatorsScreen"

const IndicatorsContainer = ({
  editedChatFields,
  values,
  handleEdit,
  handleSave,
  handleCancel,
  handleCopy,
  loadingField,
  onChangeQuestionsInfo,
  editIndex,
  formSteps,
  hasCheckBox,
  handleSelectedIndicator,
  allFields,
}) => {
  const [selected, setSelected] = useState(null)

  useEffect(() => {
    setSelected(values?.indicatorId)
  }, [values?.indicatorId])

  useEffect(() => {
    if (handleSelectedIndicator) {
      handleSelectedIndicator(selected)
    }
  }, [selected])

  const handleChangeSelected = (selected) => {
    setSelected((curr) => (curr === selected ? null : selected))
  }

  return (
    <IndicatorsScreen
      {...{
        editedChatFields,
        values,
        handleEdit,
        handleSave,
        handleCancel,
        loadingField,
        onChangeQuestionsInfo,
        editIndex,
        formSteps,
        hasCheckBox,
        handleCopy,
        handleSelectedIndicator,
        handleChangeSelected,
        selected,
        allFields,
      }}
    />
  )
}

export default IndicatorsContainer
